function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { grey40, sans, danger60, fontSize13, lineHeight } from "@churchofjesuschrist/eden-style-constants";
import { ValidityStateContext } from "./validityState";
const colorsByValidityState = {
  error: danger60,
  warning: grey40,
  success: grey40
};
export const InternalUseOnlyHint = styled.span.withConfig({
  componentId: "sc-12eqlx9-0"
})(["display:block;color:", ";font:normal normal normal ", " / ", " ", ";"], _ref => {
  let {
    validityState
  } = _ref;
  return colorsByValidityState[validityState] || grey40;
}, fontSize13, lineHeight, sans);

/**
 * The Hint provides a user with helper information about the control it is paired with.
 */
const Hint = _ref2 => {
  let {
    validityState,
    children,
    ...props
  } = _ref2;
  const validityStateContext = useContext(ValidityStateContext);
  return /*#__PURE__*/React.createElement(InternalUseOnlyHint, _extends({
    validityState: validityState ? validityState : validityStateContext
  }, props), children);
};
Hint.propTypes = {
  /** The current validity state of the Hint */
  validityState: PropTypes.oneOf(["error", "warning", "success", "unknown"]),
  /** Content to render inside the Hint Component */
  children: PropTypes.node.isRequired
};
export default Hint;